import { useEffect, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';

/**
 * The weekly mail's "Gesprek inplannen" asks for the add form on this page. Only
 * somebody who can plan here gets it; the address drops the request once the
 * form is up, so a refresh does not put the dialog back.
 */
export function usePlanRequest({ asked, canPlan }: { asked: boolean; canPlan: boolean }) {
  const navigate = useNavigate();
  const [planAsked, setPlanAsked] = useState(asked);
  const open = planAsked && canPlan;

  useEffect(() => {
    if (open) {
      void navigate({ to: '/', search: {}, replace: true });
    }
  }, [open, navigate]);

  return { asked: planAsked, open, close: () => setPlanAsked(false) };
}
